<template>
	<NuxtLayout name="default">
		<ErrorPage
			v-if="error"
			:status-code="error.statusCode"
			:status-message="error.statusMessage"
			:message="error.message"
			:back-home="$t('errors.page_not_found.back_home')"
		/>
		<NotFoundRecommendations v-if="error?.statusCode === 404" />
	</NuxtLayout>
</template>

<script setup>
import { buildPageTitle } from "~/utils/seo/titleTemplate";

const error = useError();
const siteConfig = useSiteConfig();

// `@nuxtjs/robots` stamps the site-wide `index, follow` before the status is
// known, so the error page has to override it. The header is set on this
// render's event and forwarded by Nuxt's error handler; `useRobotsRule()`
// cannot be used instead, since the robots middleware skips `/__*` renders.
if (import.meta.server) {
	useResponseHeader("X-Robots-Tag").value = "noindex, nofollow";
}

// `useError()` is a ref and `useHead` does not unwrap it — reading it without
// `.value` titled every error page "undefined - undefined".
useHead({
	title: () =>
		[error.value?.statusCode, error.value?.statusMessage]
			.filter(Boolean)
			.join(" - "),
	// error.vue renders instead of app.vue, so app.vue's template never runs
	// here and the default one appended the site name a second time.
	titleTemplate: (title) => buildPageTitle(title, siteConfig.name),
	meta: [{ name: "robots", content: "noindex, nofollow" }]
});
</script>
